import { render, staticRenderFns } from "./NewProduction.vue?vue&type=template&id=7ac048fe&scoped=true&"
import script from "./NewProduction.vue?vue&type=script&lang=js&"
export * from "./NewProduction.vue?vue&type=script&lang=js&"
import style0 from "./NewProduction.vue?vue&type=style&index=0&id=7ac048fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac048fe",
  null
  
)

export default component.exports